export default "__VITE_ASSET__Dp78Rg5v__"